import { render } from "./CatalogAttributeItemMultiAutocomplete.vue?vue&type=template&id=0666fd2e&scoped=true"
import script from "./CatalogAttributeItemMultiAutocomplete.vue?vue&type=script&lang=js"
export * from "./CatalogAttributeItemMultiAutocomplete.vue?vue&type=script&lang=js"

import "./CatalogAttributeItemMultiAutocomplete.vue?vue&type=style&index=0&id=0666fd2e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0666fd2e"]])

export default __exports__